import { useStore } from "@/stores/useStore";
import { useCallback, useState } from "react";
import { customerUpdate as customerUpdateRepository } from "@/repositories/customerUpdates";
import { useCustomerUpdates } from "@/hooks/useCustomerUpdates";

export const useSnoozeAllCustomerUpdates = () => {
  const myCustomerUpdates = useStore((s) => s.myCustomerUpdates);
  const [snoozeAllSubmitting, setSnoozeAllSubmitting] = useState(false);
  const shopId = useStore((s) => s.shop?.id);
  const { snoozeTimeMin } = useCustomerUpdates();

  const snoozeAllCustomerUpdates = useCallback(async () => {
    if (!shopId) {
      console.error("Shop ID is missing");
      return;
    }
    const desiredUpdateTime = new Date(
      new Date().getTime() + snoozeTimeMin * 60 * 1000
    ); // Convert minutes to milliseconds
    setSnoozeAllSubmitting(true);
    return await Promise.all(
      myCustomerUpdates.map((cu) => {
        if (!cu.id) {
          console.error("Customer Update ID is missing");
          return;
        }
        return customerUpdateRepository.snoozeUpdate(
          shopId,
          cu.id,
          desiredUpdateTime
        );
      })
    ).finally(() => setSnoozeAllSubmitting(false));
  }, [myCustomerUpdates, shopId, snoozeTimeMin]);

  const snoozeAllCustomerUpdatesEnabled = myCustomerUpdates.length > 1;

  return {
    snoozeAllCustomerUpdates,
    snoozeAllCustomerUpdatesEnabled,
    snoozeAllSubmitting,
  };
};
